import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Navbar from "../Navbar/Navabar";
import Footer from "../../components/Footer/Footer";
import "./About.css";

const About = () => {
  const certificates = [
    {
      id: 1,
      img: "/images/certificate-gene.jpg",
      title: "GMP Certification",
      desc: "Good Manufacturing Practice certification ensuring quality and safety.",
    },
    {
      id: 2,
      img: "/images/certifacte-2.jpg",
      title: "ISO Certification",
      desc: "ISO certification guaranteeing international quality standards.",
    },
  ];

 

  return (
    <>
      <div>
        <Navbar />
      </div>

      {/* Professional Banner */}
      <section className="professional-banner">
        <div className="banner-overlay">
          <Container>
            <Row className="align-items-center min-vh-75">
              <Col lg={8} className="mx-auto text-center">
                <h1 className="banner-title">
                  <span className="gradient-text">Gene Theraptics</span>
                </h1>
                <p className="banner-subtitle">
                  Pioneering Excellence in Animal Health & Aquaculture Solutions
                </p>
                <p className="banner-description">
                  With over two decades of expertise, we deliver innovative, sustainable solutions 
                  that enhance productivity and ensure animal welfare globally.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="scroll-indicator">
          <div className="scroll-line"></div>
        </div>
      </section>

      {/* Main Content with 4-Image Grid */}
      <section className="py-5 main-content-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-5 mb-lg-0">
              <div className="content-wrapper">
               
                <div className="title-underline"></div>
                
                <div className="content-block">
                  <h3 className="company-name">GENE THERAPTICS</h3>
                  <h4 className="company-tagline">Performance Through Excellence</h4>
                  
                  <p className="company-description">
                    Gene Theraptics is a leading manufacturer of a wide range of animal health 
                    and aquaculture products. As a technology-based enterprise, we blend traditional 
                    expertise with innovative entrepreneurship to deliver superior quality solutions.
                  </p>
                  
                  <p className="company-description">
                    Our commitment to research, development, and manufacturing excellence ensures 
                    that we provide value-added products and services of the highest international standards.
                  </p>
                  
                  <p className="company-description">
                    We invest our extensive knowledge and resources in developing sustainable ways 
                    to maintain healthy and safe livestock and aquaculture production worldwide.
                  </p>
                </div>

               
              </div>
            </Col>

            {/* 4-Image Grid Section */}
            <Col lg={6}>
              <div className="image-grid-container">
                <div className="grid-wrapper">
                  {/* Row 1 */}
                  <div className="grid-row">
                    <div className="grid-item-large">
                      <div className="grid-image-wrapper">
                        <img
                          src="/images/about3.jpeg"
                          alt="Manufacturing Facility"
                          className="grid-image"
                        />
                        <div className="image-caption">
                          <span>Manufacturing Excellence</span>
                        </div>
                      </div>
                    </div>
                    <div className="grid-item-small">
                      <div className="grid-image-wrapper">
                        <img
                          src="/images/office6.jpeg"
                          alt="Research Laboratory"
                          className="grid-image"
                        />
                        <div className="image-caption">
                          <span>Research Lab</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Row 2 */}
                  <div className="grid-row">
                    <div className="grid-item-small">
                      <div className="grid-image-wrapper">
                        <img
                          src="/images/office7.jpeg"
                          alt="Quality Control"
                          className="grid-image"
                        />
                        <div className="image-caption">
                          <span>Quality Control</span>
                        </div>
                      </div>
                    </div>
                    <div className="grid-item-large">
                      <div className="grid-image-wrapper">
                        <img
                          src="/images/about4.jpeg"
                          alt="Global Distribution"
                          className="grid-image"
                        />
                        <div className="image-caption">
                          <span>Global Reach</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Certifications Section */}
      <section className="py-5 certifications-section">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title">Our Accreditations</h2>
              <p className="section-subtitle" style={{color:"gray !important"}}>
                Certified excellence ensuring quality, safety, and trust in every product
              </p>
            </Col>
          </Row>
          
          <Row className="justify-content-center">
            {certificates.map((cert) => (
              <Col lg={5} md={6} key={cert.id} className="mb-4">
                <div className="certification-card">
                  <div className="certificate-image-container">
                    <img
                      src={cert.img}
                      alt={cert.title}
                      className="certificate-img"
                    />
                  </div>
                  <div className="certificate-content">
                    <h5>{cert.title}</h5>
                    <p>{cert.desc}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

   

      <div>
        <Footer />
      </div>
    </>
  );
};

export default About;